// import * as apis from '@apis'

const Tasks = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'newsplan-tasks',
      'docTypeCode': 'NPTASKS',
      /* 文档库ID */
      'docLib': 3
    }
  },
  getters: {},
  mutations: {},
  actions: {}
}

export default Tasks
